import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import RealisationMgmCasino from "../components/RealisationMgmCasino";

const mapStateToProps = state => ({
  lng:  state.locale.lng
});
const mapDispatchToProps = dispatch => ({});

const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(RealisationMgmCasino);
const withTranslationComponent = withTranslation(["realisations", "common"])(connectedComponent);

export default withTranslationComponent;



// WEBPACK FOOTER //
// ./src/containers/RealisationMgmCasino.js